import { render, staticRenderFns } from "./StampingAutomation.vue?vue&type=template&id=4df0e909&scoped=true&"
import script from "./StampingAutomation.vue?vue&type=script&lang=js&"
export * from "./StampingAutomation.vue?vue&type=script&lang=js&"
import style0 from "./StampingAutomation.vue?vue&type=style&index=0&id=4df0e909&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df0e909",
  null
  
)

export default component.exports